import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Checkmarx extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M17.4548418,23.7594459 L6.54450632,23.7594459 C2.93619449,23.7594459 -1.42108547e-14,20.8232514 -1.42108547e-14,17.2155915 L-1.42108547e-14,6.54450632 C-1.42108547e-14,2.93554258 2.93619449,1.42108547e-14 6.54450632,1.42108547e-14 L17.4352845,1.42108547e-14 C20.2697813,1.42108547e-14 22.6042646,1.39117208 23.5247589,3.6298248 C24.4296075,5.82610349 24,8.3424691 21.7972022,10.2825479 C21.7202771,10.3607769 20.7652316,11.0935217 20.676572,11.1593644 L13.4240934,16.4606818 C12.4664403,17.1634388 11.1202499,16.9756893 10.3914165,16.0362896 L7.19185115,11.9038435 C6.44997963,10.9468423 6.62664675,9.5680565 7.58299606,8.8274888 C8.54064919,8.08496537 9.9181312,8.25967676 10.6600027,9.21863371 L12.5518403,11.6613337 L18.8108108,7.06472905 C19.5585495,6.43433383 19.4086106,5.78568518 19.2149939,5.31500747 C18.986826,4.75892978 18.4431346,4.3860383 17.4359364,4.3860383 L6.54515822,4.3860383 C5.35477387,4.3860383 4.38734212,5.35347005 4.38734212,6.54450632 L4.38734212,17.2155915 C4.38734212,18.404672 5.35412196,19.3721038 6.54515822,19.3721038 L17.4554937,19.3721038 C18.6452261,19.3721038 19.6126579,18.4053239 19.6126579,17.2155915 L19.6126579,16.3863643 C19.6126579,15.1751188 20.5944316,14.1926932 21.8076328,14.1926932 C23.0182263,14.1926932 24,15.1751188 24,16.3863643 L24,17.2155915 C23.9993481,20.8232514 21.0618498,23.7594459 17.4548418,23.7594459" />
      </svg>
    );
  }
}

export default Checkmarx;
